export const itchPages = {
  "dont-leave-me": "https://milqz69.itch.io/dont-leave-me",
  "drive-or-die": "https://milqz69.itch.io/drive-or-die",
  "mini-me": "https://milqz69.itch.io/minime",
  eggventure: "https://tim-van-den-eng.itch.io/egg-venture",
  "sugar-rush": "https://milqz69.itch.io/sugarroll",
};

export const projectsWithItchBadges = Object.keys(itchPages);
